import { Link, Outlet, createFileRoute } from "@tanstack/react-router";

import { settingsContextRouteOptions } from "@/features/profiles/settings-context-search";

function AccountLayout() {
  return (
    <div className="container mx-auto max-w-4xl px-4 py-10">
      <h2 className="mb-8 text-3xl font-semibold">Settings</h2>
      <div className="flex gap-10">
        <nav className="w-44 shrink-0">
          <ul className="space-y-1">
            <li>
              <Link
                to="/account"
                activeOptions={{ exact: true }}
                className="text-muted-foreground hover:bg-muted hover:text-foreground block rounded-md px-3 py-2 text-sm font-medium"
                activeProps={{
                  className:
                    "block rounded-md px-3 py-2 text-sm font-medium bg-muted text-foreground",
                }}
              >
                General
              </Link>
            </li>
            <li>
              <Link
                to="/account/api-keys"
                className="text-muted-foreground hover:bg-muted hover:text-foreground block rounded-md px-3 py-2 text-sm font-medium"
                activeProps={{
                  className:
                    "block rounded-md px-3 py-2 text-sm font-medium bg-muted text-foreground",
                }}
              >
                API Keys
              </Link>
            </li>
          </ul>
        </nav>
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/account")({
  // CR-144: the workspace/project the user came from rides along as search
  // params; the middleware keeps them on every link inside Settings.
  ...settingsContextRouteOptions,
  component: AccountLayout,
});
